import React from 'react';

import { Typography, Card, CardContent, Grid, IconButton } from '@mui/material';
import { LinearProgress } from '@material-ui/core';
import LockSharpIcon from '@material-ui/icons/LockSharp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { InfoTooltip } from '../../HOC/Tooltips/index';
import { Listing, ListingLegacy, SampleEstimatorListingTypes } from 'src/interfaces/idashboard';
import { COLOR_TOOLTIP_BACKGROUND, MID_GREY, POINTER_GREEN, exchangeRates } from 'src/const';
import {
  convertCurrency,
  formatCurrency,
  getDemandByBookingTypeAndLead,
  getLTMData,
} from 'src/utils/functions';
import { DynamicBarChart } from '../../Components/Charts';
import { cardTitle, infoIconButton, infoIconStyle } from 'src/App/Dashboards/Market/styles/style';
import { COLOR_PRIMARY_1, COLOR_PRIMARY_1_600 } from 'src/colors';
import CustomProgressBarWithData from '../../Components/Bars/CustomProgressBarWithData';
import CustomProgressBarWithFixedDataInBetween from 'src/App/Components/Bars/CustomProgressBarWithFixedDataInBetween';

const BarGraphData = ({
  data,
  isDisabled,
  // estimatorSampleListingData,
  currency,
}: {
  data: any[] | Listing;
  isDisabled: boolean;
  // estimatorSampleListingData?: SampleEstimatorListingTypes;
  currency: string;
}) => {
  // const [demandByBookingType, demandByBookingLead] = getDemandByBookingTypeAndLead([data]);
  const showRevenuePotential: boolean =
    data['annualRevenueLTM'] == data['revenuePotential'] ? true : false;
  
  
  let annualRevenueLTM
  let annualRevenuePotential = data['revenuePotential']
  if(data['annualRevenueLTM']){ //for Insights data
    annualRevenueLTM = data['annualRevenueLTM']
  }else{ // for estimator data
    annualRevenueLTM = data['revenue']?getLTMData('revenue',data['revenue'],true):0
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ width: '100%' }}
      spacing={2}
    >
      <Grid item xs={12} direction="column" container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h2" sx={cardTitle}>
            Availability{' '}
            {isDisabled && <LockSharpIcon style={{ fontSize: 24, color: POINTER_GREEN }} />}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <InfoTooltip
            title={
              matchMedia('(hover:hover)').matches ? (
                <Card>
                  <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                    <Typography variant="body2" style={{ fontWeight: 500, color: MID_GREY }}>
                      The listing was available for{' '}
                      {!isDisabled ? (
                        data['activeDaysCount'] ===366 ? 365 : data['activeDaysCount']
                      ) : (
                        <LockSharpIcon style={{ fontSize: 24, color: POINTER_GREEN }} />
                      )}{' '}
                      days in the past 12 months
                    </Typography>
                  </CardContent>
                </Card>
              ) : (
                <></>
              )
            }
          >
            <div style={{ width: '100%' }}>
              <CustomProgressBarWithFixedDataInBetween
                bgcolor={COLOR_PRIMARY_1}
                progress={!isDisabled ? Math.round((data['activeDaysCount'] / 365) * 100) : 0}
                height={'20px'}
                displayText={`Available for ${data['activeDaysCount'] == 366 ? 365 : data['activeDaysCount']} days in the past 12 Months`}
                isDisabled={isDisabled}
              />
            </div>
          </InfoTooltip>
          {/* // show the avability stat text for non hoverable divices here */}
          {!matchMedia('(hover:hover)').matches && (
            <Typography
              variant="body2"
              style={{ fontWeight: 500, color: MID_GREY, marginTop: '10px' }}
            >
              The listing was available for{' '}
              {isDisabled ? <LockSharpIcon style={{ fontSize: 24, color: POINTER_GREEN }} /> :(data['activeDaysCount'] === 366 ? 365 : data['activeDaysCount'])}
              days in the past 12 months
            </Typography>
          )}
        </Grid>
      </Grid>

      <Grid item xs={12} direction="column" container spacing={1}>
        <Grid item xs={12}>
          {/* // show the avability stat text for non hoverable divices here */}
          {!matchMedia('(hover:hover)').matches && (
            <Typography
              variant="body2"
              style={{ fontWeight: 500, color: MID_GREY, marginTop: '10px' }}
            >
              The listing was available for{' '}
              {
              // estimatorSampleListingData && estimatorSampleListingData.activeDaysCount ? (
              //   estimatorSampleListingData.activeDaysCount
              // ) : 
              !isDisabled ? (
                data['activeDaysCount']
              ) : (
                <LockSharpIcon style={{ fontSize: 24, color: POINTER_GREEN }} />
              )}{' '}
              days in the past 12 months
            </Typography>
          )}
        </Grid>
      </Grid>

      {/* {data['bookings'].length > 0 && !isDisabled && (
        <Grid
          container
          item
          xs={12}
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid item md={6} sm={12} xs={12} direction="column" container spacing={1}>
            <Grid
              item
              direction="row"
              xs={12}
              container
              alignItems="center"
              justifyContent="flex-start"
            >
              <Typography variant="h2" sx={cardTitle}>
                Booking Type
              </Typography>
              <InfoTooltip
                title={
                  <Card>
                    <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                      <Grid container direction="column" alignItems="flex-start">
                        <Typography variant="body2" style={{ fontWeight: 500 }}>
                          <span style={{ fontSize: '18px' }}>Booking Types</span>
                          <br />
                          <br />
                          Single Night Stay: 1 night
                          <br />
                          Multiple Night Stays: 2-6 nights
                          <br />
                          Weekly Stay: 7-15 nights
                          <br />
                          Mid-Term Stay: 15+ nights
                        </Typography>
                      </Grid>
                    </CardContent>
                  </Card>
                }
                style={{ cursor: 'pointer' }}
              >
                <IconButton style={infoIconButton}>
                  <InfoOutlinedIcon style={infoIconStyle} />
                </IconButton>
              </InfoTooltip>
            </Grid>

            <Grid item xs={12}>
              <DynamicBarChart
                layout="vertical"
                data={demandByBookingType}
                unit="%"
                label="%"
                height={150}
                barColor={COLOR_PRIMARY_1_600}
                barAccentColor={COLOR_PRIMARY_1}
              />
            </Grid>
          </Grid>

          <Grid item md={6} sm={12} xs={12} direction="column" container spacing={1}>
            <Grid item direction="row" xs={12} container alignItems="center">
              <Typography variant="h2" sx={cardTitle}>
                Booking Lead Time
              </Typography>
              <InfoTooltip
                title={
                  <Card>
                    <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                      <Grid container direction="column" alignItems="flex-start">
                        <Typography variant="body2" style={{ fontWeight: 500 }}>
                          <span style={{ fontSize: '18px' }}>Booking Lead Times</span>
                          <br />
                          <br />
                          Last-Minute Booking: Booked less than 7 days ahead
                          <br />
                          Standard Booking: Booked 7-30 days ahead
                          <br />
                          Advance booking: Booked 30+ days ahead
                        </Typography>
                      </Grid>
                    </CardContent>
                  </Card>
                }
                style={{ cursor: 'pointer' }}
              >
                <IconButton style={infoIconButton}>
                  <InfoOutlinedIcon style={infoIconStyle} />
                </IconButton>
              </InfoTooltip>
            </Grid>

            <Grid item xs={12}>
              <DynamicBarChart
                layout="vertical"
                data={demandByBookingLead}
                unit="%"
                label="%"
                height={150}
                barColor={COLOR_PRIMARY_1_600}
                barAccentColor={COLOR_PRIMARY_1}
              />
            </Grid>
          </Grid>
        </Grid>
      )} */}
    </Grid>
  );
};

export default BarGraphData;
